<template>
    <div class="nonactivated-container">
        <div class="header pad-top15">
            <img src="@/assets/images/console/hpc.png">
            <div class="mar-left15 content">
                <b class="title mar-bot15">{{$t('欢迎使用高性能计算HPC')}}</b>
                <p class="text-grey">
                    {{$t('高性能计算（High-performance computing，HPC）是一个计算机集群系统，它通过各种互联技术将多个计算机系统连接在一起，利用所有被连接系统的综合计算能力来处理大型计算问题，所以又通常被称为高性能计算集群。HPC提供了超高浮点计算能力解决方案，可用于解决计算密集型、海量数据处理等业务的计算需求，如科学研究、气象预报、计算模拟、军事研究、CAD/CAE生物制药、基因测序、图像处理等，缩短需要的大量计算时间，提高计算精度。')}}
                </p>
            </div>
        </div>
        <div class="process mar-top10">
            <div class="content ">
                <ul class="domtree">
                    <li v-for="(process) in processList"
                        :key="process.title"
                        class="mar-right20 ">
                        <p class="cont-header">
                            <Icon :size="32"
                                  :color="process.iconColor"
                                  :type="process.icon" />
                            <b class="mar-left15">{{$t(process.title)}}</b>
                        </p>
                        <ul>
                            <li v-for="item in process.steps"
                                :key="item.title">
                                <p class="mar-bot5 pad-top20"><b>{{$t(item.title)}}</b></p>
                                <p class="text-grey mar-left20">{{$t(item.content)}}</p>
                            </li>
                        </ul>
                    </li>
                </ul>
                <p class="footer-btn">
                    <create-btn />
                </p>
            </div>
        </div>

    </div>
</template>

<script>
import createBtn from './createhpcbtn.vue'
export default {
    name: 'HpcNonactivated',
    components: {
        createBtn
    },
    data () {
        return {
            processList: [
                {
                    icon: 'md-person',
                    iconColor: '#177fea',
                    title: '用户',
                    steps: [
                        {
                            title: '1、开通高性能计算HPC',
                            content: '高性能计算与存储服务绑定,开通时需要填写默认存储空间。'
                        },
                        {
                            title: '2、申请购买产品',
                            content: '用户完成需求填写确认后,提交申请购买,等待审批通知。'
                        }
                    ]
                },
                {
                    icon: 'md-person',
                    iconColor: '#0fc1db',
                    title: '运营管理员',
                    steps: [
                        {
                            title: '1、配置服务',
                            content: '平台管理员根据用户需求进行服务配置。'
                        },
                        {
                            title: '2、审批开通',
                            content: '配置完成后审批通过,用户会收到通知邮件。'
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        openResPool () { }
    }
}
</script>

<style lang="less" scoped>
.nonactivated-container {
    .text-grey {
        color: #999;
    }
    .header {
        display: flex;
        background: #fff;
        height: 160px;
        .content {
            height: 100%;
            width: 70%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-bottom: 15px;
            .title {
                font-size: 14px;
            }
        }
    }
    .process {
        display: flex;
        align-items: center;
        height: 320px;
        padding: 15px;
        background: #fff;
        .content {
            width: 72%;
            margin-left: 220px;
        }
        .domtree {
            display: flex;
            justify-content: space-between;
            .cont-header {
                line-height: 32px;
                font-size: 14px;
                i {
                    vertical-align: middle;
                    display: inline-block;
                    width: 32px;
                    border-radius: 50%;
                    overflow: hidden;
                    text-align: center;
                }
            }
            ul {
                margin: 0;
                padding: 0 0 0 4.9em;
                .avatar {
                    display: inline-block;
                }
                li {
                    list-style: none;
                    position: relative;
                    &::before {
                        position: absolute;
                        content: '';
                        top: -0.01em;
                        left: -3em;
                        width: 2.5em;
                        height: 2.5em;
                        border-style: none none dashed dashed;
                        border-width: 0.05em;
                        border-color: #aaa;
                    }
                    &:not(:last-child) {
                        &::after {
                            position: absolute;
                            content: '';
                            top: 2.3em;
                            left: -3em;
                            bottom: 0;
                            border-style: none none none dashed;
                            border-width: 0.05em;
                            border-color: #aaa;
                        }
                    }
                    .step-content {
                        text-indent: 2em;
                    }
                }
            }
        }
    }
    .footer-btn {
        clear: both;
        text-align: center;
        padding: 30px 0 0 0;
        .btn-res {
            margin: 0 20px;
        }
    }
}
</style>
